/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_TitleInputs */

const es_marketplace_seo_galicia_faq_title = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes sobre alquiler de barcos en Galicia`)
};

const gl_marketplace_seo_galicia_faq_title = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes sobre alugueiro de barcos en Galicia`)
};

const en_marketplace_seo_galicia_faq_title = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ: boat rental in Galicia`)
};

/**
* | output |
* | --- |
* | "FAQ: boat rental in Galicia" |
*
* @param {Marketplace_Seo_Galicia_Faq_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_title = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_title(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_title(inputs)
	return es_marketplace_seo_galicia_faq_title(inputs)
});